import React, { lazy, Suspense } from 'react';
import {
    Routes,
    Route,
    Navigate,
    useLocation
} from 'react-router-dom';
import { useAppSelector } from 'hooks/useStore';

// const Landing = lazy(() => import('pages/public/Landing'));
// const SignIn = lazy(() => import('pages/public/SignIn'));
// const SignUp = lazy(() => import('pages/public/SignUp'));
// const PasswordReset = lazy(() => import('pages/public/PasswordReset'));
// const Onboarding = lazy(() => import('pages/public/Onboarding'));
// const Courses = lazy(() => import('pages/public/Courses'));
// const CourseInfo = lazy(() => import('pages/public/CourseInfo'));
// const Tests = lazy(() => import('pages/public/Tests'));
// const FullSATLevelTest = lazy(() => import('pages/public/FullSATLevelTest'));

import SignIn from 'pages/public/SignIn';
import PasswordReset from 'pages/public/PasswordReset';
import NotFound from 'pages/error/NotFound';
import Unauthorized from 'pages/error/Unauthorized';
import ServerError from 'pages/error/ServerError';

function PublicRoutes() {
    const { status } = useAppSelector(state => state.error);

    const { pathname } = useLocation();

    const signInRedirectPaths = ['/test/:testId'];

    if (status === 401) return <Unauthorized />;
    else if (status !== null) return <ServerError />;

    return (
        <Suspense fallback={<></>}>
            <Routes>
                <Route path='/' element={<Navigate to='/signin' />} />
                <Route path='/tests/digital-sat' element={<Navigate to='/signin' />} />
                <Route path='/tests/digital-psat' element={<Navigate to='/signin' />} />
                <Route path='/account' element={<Navigate to='/signin' />} />
                <Route path='/cart' element={<Navigate to='/signin' />} />

                <Route path='/signin' element={<SignIn />} />
                <Route path='/resetpassword' element={<PasswordReset />} />
                {signInRedirectPaths.map(path => (
                    <Route key={path} path={path} element={
                        <Navigate
                            to='/signin'
                            replace
                            state={{ referrer: pathname }}
                        />
                    }/>
                ))}
                
                <Route path='*' element={<NotFound />} />
            </Routes>
        </Suspense>
    );
}

export default PublicRoutes;